import { createReducer, on } from '@ngrx/store';
import { DocumentActions } from './document.actions';
import { DocumentItem } from '@core/interface/employee-document';
import { Pagination } from '@core/interface/core';

export const documentFeatureKey = 'document';

export interface DocumentState {
  documents: DocumentItem[];
  isLoading: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  isDeleted: boolean;
  pagination: Pagination;
}

export const initialState: DocumentState = {
  documents: [],
  isLoading: false,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const DocumentReducer = createReducer(
  initialState,
  on(DocumentActions.loadDocuments, (state) => ({
    ...state,
    isDeleted: false,
    loadError: null,
    isLoading: true,
  })),
  on(DocumentActions.loadDocumentsSuccess, (state, { data, pagination }) => ({
    ...state,
    documents: data,
    isLoading: false,
    isDeleted: false,
    loadError: null,
    pagination,
  })),
  on(DocumentActions.loadDocumentsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    isDeleted: false,
    loadError: error,
  })),
  on(DocumentActions.addDocumentSuccess, (state, { data }) => ({
    ...state,
    documents: [...state.documents, ...data],
    isDeleted: false,
    addEditError: null,
  })),
  on(DocumentActions.addDocumentFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(DocumentActions.updateDocumentSuccess, (state, { data }) => {
    return {
      ...state,
      documents: state.documents.map((document) =>
        data.id == document.id ? data : document
      ),
      isDeleted: false,
      addEditError: null,
    };
  }),
  on(DocumentActions.updateDocumentFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(DocumentActions.deleteDocumentSuccess, (state, { success, id }) => {
    return {
      ...state,
      isDeleted: success,
      deleteError: null,
      documents: state.documents.filter((document) => document.id !== id),
    };
  }),
  on(DocumentActions.deleteDocumentFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(DocumentActions.deleteDocument, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(DocumentActions.resetDeleteStatus, (state) => ({
    ...state,
    isDeleted: false,
  })),
  on(DocumentActions.resetDocuments, (state) => ({
    ...state,
    documents: [],
  }))
);
